import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import SignatureCanvas from 'react-signature-canvas';
import LoadingButton from '@mui/lab/LoadingButton';

import { Context } from '../../context/DataContext';
import { getImageFileName, dataURItoBlob } from '../../utils';

const StoreSignPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const sigPad = React.useRef(null);
  const { state, uploadInsurePic, setEmployeeInfo } = React.useContext(Context);
  const {
    customerInfo: { orderId },
    loginInfo: { empName },
    loginInfo: { previousSign },
  } = state;

  return (
    <Box>
      <Typography variant='h4' sx={{ my: 2 }}>
        門市簽名
      </Typography>
      <Box sx={{ px: 2 }}>
        <Typography variant='h5' sx={{ my: 2 }}>
          保險員：{empName}
        </Typography>
        {previousSign ? (
          <>
            <img
              style={{ maxWidth: '100%' }}
              src={previousSign}
              alt='store-sign'
            />
            {errorMsg ? (
              <Typography variant='h6' sx={{ my: 2, color: 'red' }}>
                {errorMsg}
              </Typography>
            ) : null}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
              }}
            >
              <Button
                color='secondary'
                variant='contained'
                sx={{ width: 128 }}
                onClick={() => {
                  setEmployeeInfo({ previousSign: '' });
                }}
              >
                重簽
              </Button>
              <LoadingButton
                variant='contained'
                sx={{ width: 128 }}
                loading={loading}
                onClick={() => {
                  if (errorMsg) setErrorMsg('');

                  setLoading(true);
                  uploadInsurePic(
                    {
                      orderId,
                      picType: 'opsignUrl',
                      picUrl: previousSign,
                      picName:
                        getImageFileName() +
                        // Get previous sign mime type
                        previousSign.slice(-4),
                    },
                    ({ responseCode, responseMsg }) => {
                      setLoading(false);

                      if (responseCode === '000') {
                        navigate('/burglary-insur/check-order-info-again');
                      } else {
                        setErrorMsg(responseMsg);
                      }
                    }
                  );
                }}
              >
                下一步
              </LoadingButton>
            </Box>
          </>
        ) : (
          <>
            <Box
              sx={{
                borderWidth: 1,
                borderRadius: 2,
                borderColor: 'rgba(0,0,0,0.23)',
                borderStyle: 'solid',
                mb: 2,
              }}
            >
              <SignatureCanvas
                ref={sigPad}
                canvasProps={{
                  style: { width: '100%', height: 168, display: 'block' },
                }}
              />
            </Box>
            {errorMsg ? (
              <Typography variant='h6' sx={{ my: 2, color: 'red' }}>
                {errorMsg}
              </Typography>
            ) : null}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
              }}
            >
              <Button
                color='secondary'
                variant='contained'
                sx={{ width: 128 }}
                onClick={() => {
                  // clear signature
                  sigPad.current.clear();
                }}
              >
                重簽
              </Button>
              <LoadingButton
                variant='contained'
                sx={{ width: 128 }}
                loading={loading}
                onClick={() => {
                  if (errorMsg) setErrorMsg('');

                  if (sigPad.current.isEmpty()) {
                    setErrorMsg('請簽名');
                  } else {
                    setLoading(true);
                    // save signature
                    const picName = getImageFileName() + '.png';
                    uploadInsurePic(
                      {
                        orderId,
                        picType: 'opsign',
                        picFile: new File(
                          [
                            dataURItoBlob(
                              sigPad.current.getCanvas().toDataURL('image/png')
                            ),
                          ],
                          picName
                        ),
                        picName,
                        picUrl: '',
                      },
                      (data) => {
                        setLoading(false);
                        const { responseCode, responseMsg } = data;

                        if (responseCode === '000') {
                          navigate('/burglary-insur/check-order-info-again');
                        } else {
                          setErrorMsg(responseMsg);
                        }
                      }
                    );
                  }
                }}
              >
                下一步
              </LoadingButton>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default StoreSignPage;
